import { render } from "./AddConfigurationModal.vue?vue&type=template&id=659bad70&ts=true"
import script from "./AddConfigurationModal.vue?vue&type=script&lang=ts"
export * from "./AddConfigurationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__